import dayjs from 'dayjs';
import axios from 'axios';
import { createSignedRequest } from './createSignedRequest';
import Config from 'Config';

/**
* Get weather data for project location
* @param {object} date object
* @returns weather data for project location
*/
export default async function fetchWeatherData({ date, hours, project }) {
    const currentDate = dayjs().format('YYYY-MM-DD');
    let queryDate;

    if (!project) return null;

    // If date is not given use current date
    if (date) {
        queryDate = date.format('YYYY-MM-DD');
    } else {
        queryDate = currentDate;
    }

    const hoursString = hours.join(',');

    return await requestWeatherData({
        city: project?.city,
        latitude: project?.latitude,
        longitude: project?.longitude,
        date: queryDate,
        hours: hoursString,
    });
};

async function requestWeatherData(body) {
    const apiPath = `weather/get-weather-data`;

    const request = {
        url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        // url: `http://localhost:3001/${apiPath}`,
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        data: body,
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
    };
    const signedRequest = await createSignedRequest(request);

    const response = await axios(signedRequest);

    return response.data;
};